import { useCallback, useEffect, useState, memo } from 'react';
import { Box, MenuItem, TextField } from '@material-ui/core';
import { dropdownStyle } from '../common/ContractTableHandlerCss';
import '../NormalViewContractDetail.css';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import Utils from '@/common/utils/utils';
import { handleChangeSelect } from '../NormalViewContractDetailHanlder';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function DropdownSelect({
    isProduct,
    isEdition,
    isPaymentCycle,
    selectedItem,
    setSelectedItem,
    selectList,
    setSelectList,
    API,
    setIsLoading,

    product,
    setProduct,
    setProductList,
    setEditionList,
    setSelectedEdition,
    setSelectedVersion,
    setBasicSetting,
    setAdvanceSetting,
    setIsUpdateConfirm,
    contractDetail
}) {
    useTranslationSubscription();
    const [itemName, setItemName] = useState('');

    useEffect(() => {
        if(!Utils.isEmptyObject(selectedItem)) {
            setItemName(selectedItem.name)
        }
    }, [selectedItem])

    const handleChange = async item => {
        setIsUpdateConfirm(true);
        if(isProduct) {
            setIsLoading(true);
            
            await handleChangeSelect(
                API,
                item,
                setSelectedItem,
                setItemName,
                setSelectList,
                null,
                null,
                null,
                setEditionList,
                setSelectedEdition,
                setSelectedVersion,
                setBasicSetting,
                setAdvanceSetting,
                contractDetail
            );

            setIsLoading(false);
            return;
        }
        if(isEdition) {
            setIsLoading(true);

            await handleChangeSelect(
                API,
                item,
                setSelectedItem, 
                setItemName,
                setSelectList,
                product,
                setProduct,
                setProductList,
                setEditionList,
                setSelectedEdition,
                setSelectedVersion,
                setBasicSetting,
                setAdvanceSetting,
                contractDetail
            );

            setIsLoading(false);
            return;
        }

        // isPaymentCycle
        setSelectedItem(item);
        setItemName(item.name);
    };

    const handlerRenderLabel = useCallback(() => {
        if (isProduct) return trI18n('DROPDOWN-SELECT-PRODUCT');
        if (isEdition) return trI18n('DROPDOWN-SELECT-EDITION');
        if (isPaymentCycle) return trI18n('DROPDOWN-PAYMENT-CYCLE');
        return '';
    }, [isProduct, isEdition, isPaymentCycle]);

    const getDisplayName = name => (isPaymentCycle ? tr(name) : name);

    return (
        <Box className="dropdown-select-container" {...dropdownStyle.dropdown_select_container}>
            <Box component="span" {...dropdownStyle.dropdown_select_label}>
                {handlerRenderLabel()}
            </Box>
            <TextField
                    className="dropdown-select-input"
                    select
                    size="small"
                    value={itemName}
                    variant="outlined"
                    data-cy="header-top-select-project"
                    SelectProps={{
                        MenuProps: {
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            },
                            getContentAnchorEl: null,
                            className: 'selectDrop'
                        }
                    }}
                    inputProps={{ className: 'selected-item-name' }}
                >
                    {!Utils.isEmptyArray(selectList) &&
                        selectList.map(item => (
                            <MenuItem
                                passed="true"
                                data-cy="drop-down-item"
                                key={item.id}
                                defaultValue=""
                                value={item.name}
                                onClick={()=> handleChange(item)}
                            >
                                <OverFlowTooltipWithTabsMui
                                    value={getDisplayName(item.name)}
                                />
                            </MenuItem>
                        ))}
                </TextField>
        </Box>
    );
}

export default memo(DropdownSelect);
